import React from "react";
import { Grid } from "@mui/material";
import BottomLinks from "../BottomLinks";
import Footer from "../Footer";
import PostSingle from "../PostSingle";

function Text() {
  const style = {
    card: {
      pt: "5rem",
    },
  };
}

export default function Heidegger01() {
  return (
    window.scrollTo(0, 0),
    (
      <div>
        <Grid container>
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={10}>
            <PostSingle props={data} />
            <BottomLinks />
          </Grid>
        </Grid>

        <Footer />
      </div>
    )
  );
}

const data = {
  image:
    "https://images.pexels.com/photos/9979101/pexels-photo-9979101.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
  title: <>درآمدی بر هایدگر</>,
  text: (
    <p>
      مساله‌ی اصلیِ هایدگر هستی است. پرسش از هستی. پرسش از معنای هستی. پرسشی که
      به فراموشی سپرده شده است. پرسشی پیشا سقراطی، پیشا افلاطونی، پیشا ارسطویی.
      پرسشی پارمیدسی. اما این فراموشی، نه از جنسِ فراموشی‌هایِ آنی، که
      فراموشی‌ای به درازنایِ تاریخِ اندیشیدن است. به فراخنای سقراط تا هگل (GA-2
      - §1).
      <p></p>
      پرسشی که زمانی تاجِ زرّینِ اندیشیدن بود و در دورانِ پیش از سقراط، قدر
      می‌دید و بر صدر می نشست، دیربازی‌ست که به فراموشی سپرده شده و به موضوعی
      پیش‌پاافتاده بدل شده است. متافیزیکِ پساسقراطی، معنای هستی را چیزی
      پیشِ‌پاافتاده و دمِ‌دستی انگاشته و فرمان به فراموشی آن داده است. ما
      نه‌تنها پرسش از معنای هستی را فراموش کرده‌ایم، که این فراموشی را نیز به
      دست فراموشی سپرده‌ایم (MaD - 172). وضعیتِ فراموشیِ فراموشی.
      <p></p>
      پروژه‌ی مارتین هایدگر، طغیان در برابر این فراموشی است. شورش در برابر
      سوژه‌ی شناسای دکارتی، منِ استعلاییِ کانتی، سوژه‌ی استعلایی هوسرلی، عصیانِ
      اونتولوژیک (هستی‌شناسیک) در برابرِ شناخت‌شناسیِ دوران مدرن. به بیان دیگر،
      پرداختن به وضعیتِ هستی‌شناسیکِ انسان به جای ِ دامن‌زدن به باورهای غالبِ
      سوژه/ابژه محور. «جادوگر کوچک مِسکیرش» زاده‌ی روستای مِسکیرش در جنوب آلمان،
      با سلاحِ «هستی» تمامیِ «شناخت‌شناسانِ» تاریخِ فلسفه را به مبارزه می‌طلبد:
      هستی در برابر شناخت. هستی‌شناسیِ بنیادی در برابر شناخت‌شناسیِ مَدرَسی و
      مدرن. تمرکز بر رویِ «خودِ» هستنده‌ها در برابر تمرکز بر دانش‌های فلسفی و
      دانشگاهی ما «درباره‌ی» هستنده‌ها. مبارزه با نوکانتی‌های شناخت‌شناس از راهِ
      پرداختن به هستی‌شناسی. تلاشِ او در جهتِ مقابله با شناخت‌شناسی و علم‌باوری
      مدرن است و برای نزدیک شدن به این هدف، توجه خود را به انسانِ «پرتاب شده در
      جهان» و زندگیِ عملی و «روزمرگیِ» او معطوف می‌دارد. قدم نهادن در «راه»ی که
      پرداختن به انسان و دغدغه‌ها و دلواپسی‌هایش را دربرگرفته است. هایدگر برای
      دستیابی به این هدف، هماره خود را در جنگی تمام عیار با متافیزیکِ ارسطو،
      دکارت، کانت و نوکانتی‌ها می‌یابد.
      <p></p>
      برای دوری از روش‌های معمولِ شناخت‌شناسانِ تاریخ فلسفه (از افلاطون تا کانت
      و هگل)، ما روشِ پدیدارشناسی را در پرداختن به «پرسش از معنای هستی» به کار
      می‌بندیم. روشی که «به سویِ خودِ چیزها» zu den Sachen selbst معطوف است و نه
      به مفهوم‌ها و نظریه‌ها و فلسفیدن‌های به ظاهر اثبات شده طیِ نسل‌های متمادی.
      در پدیدارشناسی، تئوری‌ها و باورها به‌کناری گذارده می‌شوند: روشِ ما،
      پرداختن به خودِ پدیده‌ Phenomen است. یعنی پرداختن به چیزی که خود را به ما
      نشان می‌دهد. پرداختن به چیزی که خودش-را-در-خودش-نشان می‌دهد، آشکار است و
      دلالت بر چیز (امر) دیگری ندارد. پدیده‌ها تمامِ آن چیزهایی هستند که در
      روشنایی و نور روز بر ما جلوه‌گر می‌شوند. پس هدفِ بنیادیِ ما، درهم کوفتنِ
      تمامیِ شناخت‌شناسان و سوژه/اُبژه‌ باورانِ تاریخِ فلسفه است. مبارزه با
      متافیزیکِ مدرن که انسان را چون تافته‌ای جدا بافته می‌انگارد. تافته‌ای که
      خود را سوژه‌ای شناسا و «جدا» از دیگر ابژه‌ها تعریف کرده و با تکیه بر خردِ
      خود، بر آن است تا جهانی «جدا» از خود را در آزمایش‌گاهِ عقل و علم «شناخت»
      کند. سوژه‌ی شناسای بی‌جهان و «ایزوله»ای که در ابتدا، ارتباطِ خود را از
      جهان می‌گسلد و در قدمِ دوم می‌کوشد تا با بهره‌گیری از نظریات شناخت‌شناسی،
      جهان را فهمیده و از راهِ این شناختِ «مصنوعی»، ارتباطِ گسسته‌اش با جهان را
      باز بربندد. هایدگر بر خلافِ پیشینیان‌اش که معطوف به «شناخت» و «امکانِ
      شناخت» توسط سوژه‌ی اندیشنده بودند، می‌کوشد تا با بهره‌گیری از روشِ
      پدیدارشناسی به طرح پرسش از معنای هستی و وضعیتِ انسانِ «در» جهان بپردازد.
      به گمانِ او هستی، امری پوشیده و پنهان است و بایستی درباره‌ی آن به پرسش‌گری
      پرداخت و این پرسش‌گری، تنها «آغاز» کار است. خواهیم دید که این نکته، نقطه‌ی
      مقابلِ سنتِ فلسفی‌ست که یا به قدر کافی به این پرسش نپرداخته، و یا پرسشِ
      درست را طرح نریخته است.
    </p>
  ),
};
